import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  BUTTON_VARIANT_DANGER,
  Flex,
  FlexItem
} from 'mailup-web-components'

import {
  modalConfirmResetState,
  modalCreateTextVersionState
} from '../recoil/state/modals'
import { messageState } from '../recoil/state/message'
import { saveCallback } from '../recoil/callbacks/callbacks'
import { pageState } from '../recoil/state/page'

const Footer = () => {
  const intl = useIntl()

  const { plainText, isDirty } = useRecoilValue(messageState)
  const { loading, loaded } = useRecoilValue(pageState)

  const setModalConfirmReset = useSetRecoilState(modalConfirmResetState)
  const setModalCreateTextVersion = useSetRecoilState(
    modalCreateTextVersionState
  )
  const save = useRecoilCallback(saveCallback, [])

  const handleReset = () => {
    setModalConfirmReset(prev => ({ ...prev, show: true }))
  }

  const handleCreatePlainText = () => {
    setModalCreateTextVersion(prev => ({ ...prev, show: true }))
  }

  const handleSave = () => {
    save()
  }

  return (
    <Flex justifyContent='space-between' alignItems='center' gap='8px'>
      <FlexItem>
        <Button
          kind={BUTTON_VARIANT_DANGER}
          onClick={handleReset}
          disabled={(loading && !loaded) || plainText === ''}
          data-mu-test='footer__clear-field-btn'
        >
          {intl.formatMessage({
            id: 'Load.EmailCheckUp.PlainTextVersionCleanField'
          })}
        </Button>
      </FlexItem>

      <Flex gap='8px'>
        <FlexItem>
          <Button
            kind={BUTTON_VARIANT_SECONDARY}
            onClick={handleCreatePlainText}
            disabled={loading && !loaded}
            data-mu-test='footer__create-text-version-btn'
          >
            {intl.formatMessage({
              id: 'Load.EmailCheckUp.PlainTextVersionCreate'
            })}
          </Button>
        </FlexItem>
        <FlexItem>
          <Button
            kind={BUTTON_VARIANT_PRIMARY}
            disabled={!isDirty || (loading && !loaded)}
            onClick={handleSave}
            data-mu-test='footer__save-btn'
          >
            {intl.formatMessage({
              id: 'Load.EmailCheckUp.PlainTextVersionSave'
            })}
          </Button>
        </FlexItem>
      </Flex>
    </Flex>
  )
}

export default Footer
